namespace Gamification.Gamification {
    export namespace UtentiProdottiEsperienzeService {
        export const baseUrl = 'Gamification/UtentiProdottiEsperienze';

        export declare function Create(request: Serenity.SaveRequest<UtentiProdottiEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<UtentiProdottiEsperienzeRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<UtentiProdottiEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<UtentiProdottiEsperienzeRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Gamification/UtentiProdottiEsperienze/Create",
            Update = "Gamification/UtentiProdottiEsperienze/Update",
            Delete = "Gamification/UtentiProdottiEsperienze/Delete",
            Retrieve = "Gamification/UtentiProdottiEsperienze/Retrieve",
            List = "Gamification/UtentiProdottiEsperienze/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>UtentiProdottiEsperienzeService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
